<template>
  <div id="custom_request_counter_offer_submit" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="exampleModalLiveLabel" aria-hidden="true">
    <loading-modal :is-loading="isLoading"></loading-modal>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content closefriend-modal">
        
        <!-- Header -->
        <div class="modal-header border-0 pb-0 d-flex align-items-center justify-content-between pt-4 px-4">
          <h5 class="modal-title text-white font-weight-500 m-0">Submit Counter Offer</h5>
          <button type="button" class="close text-white m-0 p-0" data-dismiss="modal" aria-label="Close" style="opacity: 0.8; outline: none;">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- Body -->
        <div class="modal-body text-left pt-4 pb-4 px-4">
          <model-global-message :global-errors="globalErrors" :message="message" @clearMessages="clearMessages()"/>

          <div class="mb-4">
            <label class="font-size-12 text-muted mb-2 text-uppercase letter-spacing-1 d-block">Message (Optional)</label>
            <textarea class="coloredInput2 w-100 text-white p-3" rows="3"
                      placeholder="Enter a message for your counter offer..."
                      v-model="customRequest.counterOfferDescription"></textarea>
          </div>

          <div class="mb-2">
            <div class="d-flex justify-content-between align-items-end mb-2">
              <label class="font-size-12 text-muted m-0 text-uppercase letter-spacing-1">Counter Offer Amount</label>
              <span class="font-size-12 text-muted">Original Offer: ${{customRequest.offerPrice}}</span>
            </div>
            
            <div class="d-flex align-items-center">
              <span class="text-white font-weight-bold me-2 font-size-16">$</span>
              <input type="number" min="0" class="coloredInput2 text-white px-3 py-2" 
                     style="width: 150px;"
                     placeholder="0"
                     onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
                     v-model="customRequest.counterOfferPrice">
            </div>
            <span class="text-danger font-size-12 mt-1 d-block" v-if="isRequired('counterOfferPrice')">This is required field</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-footer border-0 d-flex flex-row align-items-center justify-content-end px-4 pb-4 pt-0">
          <button class="btn button-class text-white m-0" @click="submitCounterOffer()" style="color: white !important;">
            Submit
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {influencerCustomRequestMixin} from "@/mixin/influencer-custom-request-mixin";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import {required} from "vuelidate/lib/validators";
import {CR_TYPE_INFLUENCER} from "@/properties/custom-request-status";
import {clone} from "@/common/Utils";

export default {
  name: "ModelCustomRequestCounterOfferSubmit",
  props: {
    type: {
      type: String,
      default: CR_TYPE_INFLUENCER
    }
  },
  mixins: [influencerCustomRequestMixin],
  data() {
    return {
      counterOfferPrice: null
    }
  },
  validations: {
    customRequest: {
      counterOfferPrice: {required},
    }
  },
  methods: {
    show(customRequest) {
      this.clearMessages();
      this.customRequest = customRequest;
      this.counterOfferPrice = clone(this.customRequest.counterOfferPrice);
      console.log('counterOfferPrice', this.counterOfferPrice);
      this.customRequest.counterOfferDescription = null;
      this.customRequest.counterOfferPrice = null;
      $('#custom_request_counter_offer_submit').modal();
    },
    hide() {
      $('#custom_request_counter_offer_submit').modal('hide');
    },
    submitCounterOffer() {
      this.isSubmitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      let id = this.customRequest.id;
      let url;
      if (this.type === CR_TYPE_INFLUENCER) {
        let influencerId = this.customRequest.influencer.id;
        url = `${SERVICE_CONTENT}/api/v1/influencers/${influencerId}/custom-request/${id}/counter-offer`;
      } else {
        let customerId = this.customRequest.customer.id;
        url = `${SERVICE_CONTENT}/api/v1/customers/${customerId}/custom-request/${id}/counter-offer`;
      }

      this.patchData(url, this.customRequest, (customRequest) => {
        this.customRequest = customRequest;
        this.hide();
        this.$emit("counterOfferSubmitted");
      });
    }
  }
}
</script>

<style scoped>
.button-class {
    background: linear-gradient(90deg, #F3DA6B 0%, #E53BB9 100%) !important;
    color: white !important;
    border: none !important;
    width: auto !important;
    min-width: 120px !important;
    height: 40px !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.button-class2 {
    background: rgba(255, 255, 255, 0.2) !important;
    color: white !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    width: auto !important;
    min-width: 120px !important;
    height: 40px !important;
    border-radius: 8px !important;
    padding: 8px 16px !important;
    font-weight: 600 !important;
    font-size: 0.875rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
}

.button-class2:hover {
    background: rgba(255, 255, 255, 0.3) !important;
    color: white !important;
}
</style>
